import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import { Permission } from 'garaje/utils/ui-permissions';

export default class EmployeeInviteAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;

  get canSignIn(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.WORKPLACE_EMPLOYEE_INVITE_CREATE);
  }

  get canExportAll(): boolean {
    if (this.featureFlags.isEnabled('workplace-permission-export-employee-log')) {
      return this.authz.hasPermissionAtCurrentLocation(Permission.WORKPLACE_EMPLOYEE_INVITE_EXPORT);
    }
    return true;
  }
}
